import { Alert, SimpleGrid, Stack } from '@mantine/core';
import { PerformanceCardSkeleton } from '../PerformanceCardSkeleton';
import { EngagementsCard } from './cards/EngagementsCard';
import { EventsPulseCard } from './cards/EventsPulseCard';
import { ParticipantEducationCard } from './cards/ParticipantEducationCard';
import { ParticipantsOverviewCard } from './cards/ParticipantsOverviewCard';
import { useDashboardSectionData } from '../hooks/useDashboardSectionData';
import { mapApiToBlackTechStreetData } from './helpers';

export function BlackTechStreetPerformanceMetrics() {
  const { mappedData, error, isLoading } = useDashboardSectionData({
    queryKey: 'black-tech-street',
    fallbackGroupId: 'Black Tech Street',
    enabled: (group) => group === 'Black Tech Street',
    mapData: mapApiToBlackTechStreetData,
  });
  const hasApiData = mappedData !== null;

  return (
    <Stack spacing="lg">
      {error ? (
        <Alert color="yellow" variant="light">
          Unable to load dashboard API data.
        </Alert>
      ) : null}
      {!isLoading && !hasApiData ? (
        <Alert color="yellow" variant="light">
          No dashboard API data returned for this section.
        </Alert>
      ) : null}
      {isLoading && !hasApiData ? (
        <SimpleGrid
          cols={2}
          spacing="lg"
          breakpoints={[
            { maxWidth: 1200, cols: 2 },
            { maxWidth: 900, cols: 1 },
          ]}
        >
          <PerformanceCardSkeleton />
          <PerformanceCardSkeleton />
          <PerformanceCardSkeleton />
          <PerformanceCardSkeleton />
        </SimpleGrid>
      ) : null}
      {hasApiData ? (
        <SimpleGrid
          cols={2}
          spacing="lg"
          breakpoints={[
            { maxWidth: 1200, cols: 2 },
            { maxWidth: 900, cols: 1 },
          ]}
        >
          <ParticipantsOverviewCard data={mappedData!} />
          <ParticipantEducationCard data={mappedData!} />
          <EngagementsCard data={mappedData!} />
          <EventsPulseCard data={mappedData!} />
        </SimpleGrid>
      ) : null}

    </Stack>
  );
}
